module.exports = __webpack_public_path__ + "static/vlad-s-644a437a6f01bf1c3f7f9ebbd973ed90.png";